<template>
	<div class="d-flex pages a-center j-center pb-50">
		<el-pagination modelValue:current-page="currentPage" modelValue:page-size="pageSize" :page-sizes="pageSizes"
			:disabled="disabled" :default-page-size="pageSizes[0]" :background="background"
			layout="total, sizes, prev, pager, next, jumper" size="large" :total="total" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" />
	</div>
</template>

<script>
	export default {
		name: "pagination",

		data() {
			return {
				prev: false,
				disabled: false,
				background: true
			}
		},
		props: {
			total: {
				type: Number,
				default: 1
			},
			currentPage: {
				type: Number,
				default: 1
			},
			pageSize: {
				type: Number,
				default: 10
			},
			pageSizes: {
				type: Array,
				default: [10, 20, 50, 100]
			}

		},
		methods: {
			handleSizeChange(e) {
				this.$emit('pageClick', {
					sta: 'sizeChange',
					size: e
				})
			},
			handleCurrentChange(e) {
				this.$emit('pageClick', {
					sta: 'curChange',
					curPage: e
				})
			}
		}
	}
</script>

<style lang="scss">
	.el-pagination {
		font-size: 18px;
	}

	.el-select__wrapper {
		font-size: 16px;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).is-active {
		background-color: #389523;
		color: #fff;
	}

	.el-pagination.is-background .el-pager li:not(.disabled).is-active:hover {
		color: #fff;
	}

	.el-pagination.is-background .el-pager li:not(.disabled):hover {
		color: #389523;
	}
</style>